import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
  selector:'[maxValue]',
  providers:[
    {
      provide:NG_VALIDATORS,
      useExisting:MaxValue,
      multi:true,
    }
  ]
})
export class MaxValue implements Validator{
  @Input() maxValue
  validate(control: AbstractControl):{[key:string]:boolean}|null {
    const value=+control.value
    if(value>this.maxValue)return {'maxValueError':true}
    else return null
  }

}
